import React from 'react';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import Stack from '../Stack';
import Label from '../Label';

import SegmentButton from './components/SegmentButton';

const replaceSelectedSegment = (selectedSegments, segmentValue, segmentIndex, defaultSegment) => {
  const result = [
    ...selectedSegments.slice(0, segmentIndex),
    segmentValue,
    ...selectedSegments.slice(segmentIndex + 1),
  ].filter(Boolean);

  const fillStart = result.length;
  result.length = selectedSegments.length;
  result.fill(undefined, fillStart, selectedSegments.length);

  if (!result[0]) {
    result[0] = defaultSegment;
  }

  return result;
};

const getObjectWithoutId = (object) => {
  const result = { ...object };
  delete result.id;

  return result;
};

const SegmentPicker = ({
  selected, items, isLoading, canManage, onItemSelected, onManage, onToggle, onInfo, dataId, labels, disabled, favoriteOnClick,
  appearance,
}) => {
  // Id is removed in comparision since ActionList adds it to selected object
  const isZeroState = !selected[1] && isEqual(getObjectWithoutId(selected[0]), items[0]);
  const compareMode = selected.every(Boolean) && selected.length > 1;
  const isSidebar = appearance === 'sidebar';

  return (
    <Stack spacing="narrow" dataId={dataId} wrap vertical={isSidebar}>
      {selected.map((segment, index, selectedSegments) => {
        const withAction = index !== 0 || !isZeroState;
        const segmentProps = segment
          ? {
            segment,
            withAction,
            onRemove: () => {
              onItemSelected(
                replaceSelectedSegment(selectedSegments, undefined, index, items[0]),
              );
            },
          }
          : null;

        return (
          // eslint-disable-next-line react/no-array-index-key
          <Stack.Item key={index} fill={isSidebar}>
            <Stack vertical spacing="extraNarrow">
              {labels.length > 0 && (
                <Stack.Item>
                  <Label type="small">
                    {labels[index]}
                  </Label>
                </Stack.Item>
              )}
              <Stack.Item fill={isSidebar}>
                <SegmentButton
                  {...segmentProps}
                  slot={index}
                  isLoading={isLoading}
                  items={items}
                  withInfo={
                    !isEqual(getObjectWithoutId(segment), items[0])
                    && !(get(segment, 'error'))
                    && onInfo !== null
                  }
                  canManage={canManage}
                  compareMode={compareMode}
                  onItemSelected={(newSegment) => {
                    onItemSelected(replaceSelectedSegment(selectedSegments, newSegment, index));
                  }}
                  onInfo={onInfo}
                  onManage={onManage}
                  onToggle={onToggle}
                  dataId={`${dataId}.segment`}
                  disabled={disabled}
                  favoriteOnClick={favoriteOnClick}
                  appearance={appearance}
                />
              </Stack.Item>
            </Stack>
          </Stack.Item>
        );
      })}
    </Stack>
  );
};

SegmentPicker.defaultProps = {
  isLoading: false,
  canManage: false,
  dataId: 'SegmentPicker',
  appearance: 'default',
  onInfo: null,
  labels: [],
  disabled: false,
};

export default SegmentPicker;
